import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

function GoogleAuth({ init }) {

    // console.log("GoogleAuthPageStart");
    useEffect(() => {
    // console.log("GoogleAuthUseEffectStart");
        window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
    }, [])

    return (
        <>
        </>
    );
}
export default observer(GoogleAuth);